import React, { useEffect } from 'react';
import { Box, Typography, CircularProgress, Chip } from '@mui/material';
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import moment from 'moment';
import * as patientActions from "../redux/actions/patientActions";
import { useDispatch, useSelector } from 'react-redux';

const PatientConditionTimeline = ({ patientId }) => {
    const dispatch = useDispatch();

    const timelineData = useSelector(
        (state) => state.patientReducer.conditionTimeline
    );
    const loading = useSelector(
        (state) => state.patientReducer.conditionTimelineLoading
    );
    useEffect(() => {
        if (patientId) {
            dispatch(patientActions.getConditionTimelineRequestAction(patientId));
        }
    }, [patientId, dispatch]);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', p: 2 }}>
                <CircularProgress size={30} />
            </Box>
        );
    }

    if (!timelineData || !timelineData.incidents || timelineData.incidents.length === 0) {
        return (
            <Box sx={{ p: 2 }}>
                <Typography align="center">No condition history found.</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{
            // width: '100%', 
            height: '100%',
            overflowY: {md:'auto',xs:'hidden'},
            marginBottom: 7,
            backgroundColor: 'transparent',
            '&::-webkit-scrollbar': { display: 'none' },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
        }}>
            <Typography align="left" sx={{ fontWeight: 600, fontSize: '14px', pl: 1, mb: 0 }}>
                Her Journey
            </Typography>

            <Timeline
                sx={{
                    [`& .${timelineItemClasses.root}:before`]: {
                        flex: 0,
                        padding: 0,
                    },
                    pl: 1, pr: 1, pt: 0, pb: 1, m: 0
                }}
            >
                {timelineData.incidents.map((incident, index) => (
                    <TimelineItem key={incident.incidentId || index}>
                        <TimelineSeparator>
                            <TimelineDot color={incident.status === 'ACTIVE' ? "primary" : "grey"} />
                            {index < timelineData.incidents.length - 1 && <TimelineConnector />}
                        </TimelineSeparator>
                        <TimelineContent sx={{ py: '9px', px: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                                <Typography variant="subtitle2" component="span" sx={{ fontWeight: 500, color: '#808080' }}>
                                    {moment(incident.segmentStart).format('MMM YYYY')}
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {incident.conditions && incident.conditions.map((cond, cIndex) => (
                                    <Chip
                                        key={cond.patientConditionId || cIndex}
                                        label={cond.name}
                                        size="small"
                                        sx={{
                                            // backgroundColor: cond.status === 'ACTIVE' ? '#EEF4FF' : '#F5F5F5',
                                            backgroundColor: '#EEF4FF',
                                            // color: cond.status === 'ACTIVE' ? '#2563EB' : '#666',
                                            color: '#2563EB',
                                            fontWeight: 500,
                                            height: 'auto',
                                            maxWidth: '100%',
                                            '& .MuiChip-label': {
                                                display: 'block',
                                                whiteSpace: 'normal',
                                                wordBreak: 'break-word'
                                            }
                                        }}
                                    />
                                ))}
                            </Box>
                        </TimelineContent>
                    </TimelineItem>
                ))}
            </Timeline>
        </Box>
    );
};

export default PatientConditionTimeline;
